import styles from "./searchFilters.module.css";

import {
  Flex,
  Button,
  Input,
  Dropdown,
  Divider,
  Checkbox,
  Descriptions,
} from "antd";

import SearchIcon from "@/icons/Search";
import SortAscendingIcon from "@/icons/SortAscendingIcon";
import SortDescendingIcon from "@/icons/SortDescendingIcon";
import FilterIcon from "@/icons/FilterIcon";

import CustomSelect from "@/components/inputs/CustomSelect";
import CustomTreeSelect from "@/components/inputs/CustomTreeSelect";
import FiltersModal from "@/components/modals/FiltersModal";

import { ACCESS_LEVELS } from "@/constants/tasks";

import { SORT_OPTIONS, FILTER_NAMES, SECTIONS_OPTIONS } from "../constants";

const SearchFilters = ({
  isAdmins,
  pending,
  searchInput,
  units,
  unitsTree,
  tableParams,
  selectedSections,
  isAllSectionsSelected,
  tempFilters,
  tempSelectedSections,
  isAllTempSectionsSelected,
  isFiltersModalShow,
  applySearch,
  handleSearchChange,
  handleFilterChange,
  handleSortChange,
  handleToggleAllSections,
  openFiltersModal,
  handleTempFilterChange,
  handleApplyModalFilters,
  handleResetModalFilters,
  handleCancelModalFilters,
  handleToggleAllTempSections,
}) => {
  return (
    <>
      {/* Поиск + фильтры */}
      <Flex justify="space-between" gap={8} className={styles.filtersWrap}>
        <Flex gap={8} align="center" className={styles.filtersControls}>
          {/* Поиск с ручным триггером (кнопка/Enter). */}
          <Input.Search
            className={styles.searchInput}
            allowClear
            placeholder="Начните вводить"
            value={searchInput}
            onChange={handleSearchChange}
            onSearch={(val) => {
              // if (val?.length >= 3) { ANYA три символа
                applySearch(val);
              // }
            }}
            onClear={() => applySearch("")}
            enterButton={
              <Button
                // disabled={searchInput.length < 3} ANYA три символа
                type="primary"
                loading={pending}
                icon={<SearchIcon style={{ fontSize: 14 }} />}
              />
            }
          />

          <Flex gap={8} align="center" className={styles.desktopFilters}>
            <CustomSelect
              mode="multiple"
              placeholder="Все сущности"
              options={SECTIONS_OPTIONS}
              style={{ width: 180 }}
              maxTagCount="responsive"
              menuItemSelectedIcon={null}
              popupMatchSelectWidth={false}
              value={tableParams.filters.search_entity_types}
              onChange={(val) => handleFilterChange(FILTER_NAMES.SECTIONS, val)}
              optionRender={(option) => {
                const optionValue = option?.data?.value;

                return (
                  <Flex align="center" gap={10}>
                    <Checkbox
                      checked={selectedSections.includes(optionValue)}
                      style={{ pointerEvents: "none" }}
                    />
                    <span style={{ fontWeight: 400 }}>{option.label}</span>
                  </Flex>
                );
              }}
              popupRender={(menu) => (
                <>
                  <Flex
                    align="center"
                    gap={10}
                    style={{
                      padding: "5px 12px",
                      cursor: "pointer",
                      userSelect: "none",
                    }}
                    onClick={handleToggleAllSections}
                  >
                    <Checkbox
                      checked={isAllSectionsSelected}
                      style={{ pointerEvents: "none" }}
                    />
                    <span>Все сущности</span>
                  </Flex>
                  <Divider
                    style={{ margin: "5px 0", borderColor: "#E9E9E9" }}
                  />
                  {menu}
                </>
              )}
            />

            {/* Набор фильтров зависит от роли пользователя. */}
            {isAdmins ? (
              <CustomSelect
                placeholder="Все рабочие группы"
                options={units}
                fieldNames={{ label: "name", value: "uuid", key: "uuid" }}
                style={{ width: 180 }}
                showSearch
                optionFilterProp="name"
                allowClear
                popupMatchSelectWidth={false}
                value={tableParams.filters.unit_uuid}
                onChange={(unit) =>
                  handleFilterChange(FILTER_NAMES.UNIT_UUID, unit)
                }
              />
            ) : (
              <>
                <CustomTreeSelect
                  placeholder="Все рабочие группы"
                  data={unitsTree}
                  value={tableParams.filters.units_uuids}
                  onChange={(units_uuids) => {
                    handleFilterChange(FILTER_NAMES.UNITS_UUIDS, units_uuids);
                  }}
                  style={{ width: 180 }}
                />

                {/* Тип доступа влияет на автоподстановку units_uuids. */}
                <CustomSelect
                  placeholder="Тип"
                  options={ACCESS_LEVELS}
                  style={{ width: 135 }}
                  popupMatchSelectWidth={false}
                  value={tableParams.filters.type_filter}
                  onChange={(val) =>
                    handleFilterChange(FILTER_NAMES.ACCESS_LEVEL, val)
                  }
                  optionRender={(option) => (
                    <Flex gap={5} align="center">
                      {option?.data?.icon}
                      <span>{option.label}</span>
                    </Flex>
                  )}
                  labelRender={(option) => {
                    const item = ACCESS_LEVELS.find(
                      (item) => item.value === option.value,
                    );

                    return (
                      <Flex gap={5} align="center">
                        {item?.icon}
                        <span>{item.label}</span>
                      </Flex>
                    );
                  }}
                />
              </>
            )}
          </Flex>

          <div className={styles.mobileFilters}>
            <Button
              type="primary"
              icon={<FilterIcon />}
              onClick={openFiltersModal}
            />
          </div>
        </Flex>

        {/* Десктопный вариант сортировки. */}
        <CustomSelect
          placeholder="Сортировка"
          options={SORT_OPTIONS}
          popupMatchSelectWidth={false}
          value={tableParams.sort}
          onChange={handleSortChange}
          className={styles.bigSorting}
        />

        {/* Компактный (мобильный) вариант сортировки. */}
        <div className={styles.smallSorting}>
          <Dropdown
            menu={{
              items: SORT_OPTIONS,
              selectable: true,
              selectedKeys: [tableParams.sort],
              onClick: (e) => {
                handleSortChange(e.key);
              },
            }}
            trigger={["click"]}
          >
            <Button
              icon={
                tableParams.sort?.startsWith("-") ? (
                  <SortDescendingIcon style={{ fontSize: 16 }} />
                ) : (
                  <SortAscendingIcon style={{ fontSize: 16 }} />
                )
              }
            />
          </Dropdown>
        </div>
      </Flex>

      {isFiltersModalShow && (
        <FiltersModal
          visible={isFiltersModalShow}
          onSave={handleApplyModalFilters}
          onCancel={handleCancelModalFilters}
          onClear={handleResetModalFilters}
        >
          <Descriptions
            column={1}
            colon={false}
            styles={{
              label: {
                display: "inline-block",
                minWidth: "150px",
                color: "#777777",
              },
              content: {
                display: "block",
                marginLeft: "8px",
              },
            }}
          >
            <Descriptions.Item label="Сущности">
              <CustomSelect
                mode="multiple"
                placeholder="Все сущности"
                options={SECTIONS_OPTIONS}
                className="w-100"
                maxTagCount="responsive"
                menuItemSelectedIcon={null}
                popupMatchSelectWidth={false}
                value={tempFilters.search_entity_types}
                onChange={(val) =>
                  handleTempFilterChange(FILTER_NAMES.SECTIONS, val)
                }
                optionRender={(option) => {
                  const optionValue = option?.data?.value;

                  return (
                    <Flex align="center" gap={10}>
                      <Checkbox
                        checked={tempSelectedSections.includes(optionValue)}
                        style={{ pointerEvents: "none" }}
                      />
                      <span style={{ fontWeight: 400 }}>{option.label}</span>
                    </Flex>
                  );
                }}
                popupRender={(menu) => (
                  <>
                    <Flex
                      align="center"
                      gap={10}
                      style={{
                        padding: "5px 12px",
                        cursor: "pointer",
                        userSelect: "none",
                      }}
                      onClick={handleToggleAllTempSections}
                    >
                      <Checkbox
                        checked={isAllTempSectionsSelected}
                        style={{ pointerEvents: "none" }}
                      />
                      <span>Все сущности</span>
                    </Flex>
                    <Divider
                      style={{ margin: "5px 0", borderColor: "#E9E9E9" }}
                    />
                    {menu}
                  </>
                )}
              />
            </Descriptions.Item>

            {isAdmins ? (
              <Descriptions.Item label="Рабочая группа">
                <CustomSelect
                  placeholder="Все рабочие группы"
                  options={units}
                  fieldNames={{ label: "name", value: "uuid", key: "uuid" }}
                  className="w-100"
                  showSearch
                  optionFilterProp="name"
                  allowClear
                  popupMatchSelectWidth={false}
                  value={tempFilters.unit_uuid}
                  onChange={(unit) =>
                    handleTempFilterChange(FILTER_NAMES.UNIT_UUID, unit)
                  }
                />
              </Descriptions.Item>
            ) : (
              <>
                <Descriptions.Item label="Рабочая группа">
                  <CustomTreeSelect
                    placeholder="Все рабочие группы"
                    data={unitsTree}
                    value={tempFilters.units_uuids}
                    onChange={(units_uuids) => {
                      handleTempFilterChange(
                        FILTER_NAMES.UNITS_UUIDS,
                        units_uuids,
                      );
                    }}
                    style={{ width: "100%" }}
                  />
                </Descriptions.Item>

                <Descriptions.Item label="Тип доступа">
                  <CustomSelect
                    placeholder="Тип"
                    options={ACCESS_LEVELS}
                    className="w-100"
                    popupMatchSelectWidth={false}
                    value={tempFilters.type_filter}
                    onChange={(val) =>
                      handleTempFilterChange(FILTER_NAMES.ACCESS_LEVEL, val)
                    }
                    optionRender={(option) => (
                      <Flex gap={5} align="center">
                        {option?.data?.icon}
                        <span>{option.label}</span>
                      </Flex>
                    )}
                    labelRender={(option) => {
                      const item = ACCESS_LEVELS.find(
                        (item) => item.value === option.value,
                      );

                      return (
                        <Flex gap={5} align="center">
                          {item?.icon}
                          <span>{item.label}</span>
                        </Flex>
                      );
                    }}
                  />
                </Descriptions.Item>
              </>
            )}
          </Descriptions>
        </FiltersModal>
      )}
    </>
  );
};

export default SearchFilters;
